var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDutiesTaxesReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55534 18.57H12.6473V31H16.4093V18.57H20.5013V15.556H8.55534V18.57ZM32.9274 31H36.9094L31.3214 15.556H26.9654L21.3774 31H25.3154L26.2394 28.272H32.0034L32.9274 31ZM31.0354 25.368H27.2294L29.1214 19.714L31.0354 25.368ZM48.0701 31H52.4481L47.3441 23.344L52.2501 15.556H47.9821L45.2541 20.22L42.1521 15.556H37.7741L42.8341 23.146L37.8841 31H42.1521L44.9241 26.27L48.0701 31Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDutiesTaxesReport);
export default __webpack_public_path__ + "static/media/duties-taxes-report.67c1d83aa99f2bc67e52718a9152bf5c.svg";
export { ForwardRef as ReactComponent };